import PropTypes from "prop-types";
import { AutoComponent as AutoRecallDetails } from "./../recall-details/auto";
import { useState } from "react";
import { SignatureDisplay } from "./signatureDisplay";

export const AutoComponent = ({
  recallDetails,
  issueDetails,
  signatures = [],
  isLoadingSignatures = false,
  onImageError,
  imageErrors = {},
  formatDate
}) => {
  const [showMore, setShowMore] = useState(false);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <AutoRecallDetails item={recallDetails} showRestData={showMore} />

      <button
        onClick={() => setShowMore(!showMore)}
        onKeyPress={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            setShowMore(!showMore);
          }
        }}
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          cursor: "pointer",
          border: "none",
          backgroundColor: "transparent",
          outline: "none"
        }}
      >
        <p
          style={{
            color: "#007bff",
            fontSize: "14px",
            fontWeight: "bold",
            textDecoration: "underline"
          }}
        >
          {!showMore ? "Show More" : "Show Less"}
        </p>
      </button>

      {/* Issue Description */}
      {issueDetails?.description && (
        <div className="recall-details-body-item">
          <h2>Issue Description</h2>
          <p>{issueDetails.description}</p>
        </div>
      )}

      {/* Issue Attachment */}
      {(() => {
        const attachment = issueDetails?.attachment;
        if (!attachment) {
          return null;
        }

        try {
          const parsedAttachment = JSON.parse(attachment);
          const isAttachment = parsedAttachment?.length > 0;
          if (!isAttachment) {
            return null;
          }
          const attachmentUrl = parsedAttachment[0]?.url;
          const attachmentName = parsedAttachment[0]?.filename;
          return (
            <div className="recall-details-body-item">
              <h2>Attachment</h2>
              <span style={{ display: "flex", alignItems: "center" }}>
                <span>{attachmentName || "Attachment"}</span>
                <a
                  href={attachmentUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    textDecoration: "none",
                    paddingLeft: "10px",
                    display: "flex",
                    alignItems: "center"
                  }}
                >
                  <i className="fa fa-download"></i>
                </a>
              </span>
            </div>
          );
        } catch (error) {
          console.error('Error parsing attachment:', error);
          return null;
        }
      })()}

      {/* Signatures Section */}
      <div className="recall-details-body-item">
        <h2>Signature</h2>
        <SignatureDisplay
          signatures={signatures}
          isLoading={isLoadingSignatures}
          onImageError={onImageError}
          imageErrors={imageErrors}
          formatDate={formatDate}
        />
      </div>
    </div>
  );
};

AutoComponent.propTypes = {
  recallDetails: PropTypes.shape({
    recall_title: PropTypes.string,
    id: PropTypes.string,
    created_on: PropTypes.string,
    manufacturer: PropTypes.string,
    make: PropTypes.string,
    model: PropTypes.string,
    model_year: PropTypes.string,
    status: PropTypes.string
  }).isRequired,
  issueDetails: PropTypes.object.isRequired,
  signatures: PropTypes.array,
  isLoadingSignatures: PropTypes.bool,
  onImageError: PropTypes.func,
  imageErrors: PropTypes.object,
  formatDate: PropTypes.func
};

AutoComponent.defaultProps = {
  signatures: [],
  isLoadingSignatures: false,
  onImageError: () => { },
  imageErrors: {},
  formatDate: (date) => new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
};